import predefinedPresets from './AllPresets/index'
import store from '@/store'

for (let i in predefinedPresets) {
  if (localStorage.presets && JSON.parse(localStorage.presets)[i]) {
    try {
      const css = JSON.parse(localStorage.presets)[i].style
      predefinedPresets[i].style = css
    } catch (err) { console.log(err) }
  }
}

let userPresets = null

try {
  userPresets = JSON.parse(localStorage.getItem('presets'))
} catch (error) {}

const predefinedPresetsNameAsLabel = {}
const allCustomCss = {}
for (let preset in predefinedPresets) {
  predefinedPresetsNameAsLabel[predefinedPresets[preset].label] = predefinedPresets[preset]
  allCustomCss[predefinedPresets[preset].label] = predefinedPresets[preset].style
}

try {
  store.commit('setCustomCss', allCustomCss)
  store.commit('setPresetName', predefinedPresetsNameAsLabel.DefaultPreset.label)
} catch (err) {
  setTimeout(() => {
    store.commit('setCustomCss', allCustomCss)
  }, 500)
}

export { predefinedPresetsNameAsLabel as presets, userPresets }
